import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ImmunizationsListBody from "components/PatientManagement/Immunizations/ImmunizationsListBody";

export default function Immunizations() {
  useEffect(() => {
    document.title = "Immunizations";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <ImmunizationsListBody />
    </main>
  );
}
